import { rootApi } from '../../root-api'

const api = rootApi.injectEndpoints({
  endpoints: (build) => ({
    fetchEligibility: build.query({
      query: () => ({ url: '/api/seat_requests/eligibility' })
    }),
    fetchRequestableOrgs: build.query({
      query: () => ({ url: '/api/seat_requests/requestable_organizations' })
    }),
    submitRequestToJoin: build.mutation({
      query: (orgUuid) => ({
        url: '/api/seat_requests',
        method: 'POST',
        data: { org_uuid: orgUuid }
      }),
    }),
    cancelRequest: build.mutation({
      query: (requestUuid) => ({
        url: `/api/seat_requests/${requestUuid}`,
        method: 'DELETE'
      })
    })
  })
})

export const {
  useFetchEligibilityQuery,
  useFetchRequestableOrgsQuery,
  useLazyFetchEligibilityQuery,
  useSubmitRequestToJoinMutation,
  useCancelRequestMutation
} = api
